// extracted by mini-css-extract-plugin
export default {"content":"ModalSolutionOutPosition_content__mUiNp","field":"ModalSolutionOutPosition_field__BSxYq","buttonStyle":"ModalSolutionOutPosition_buttonStyle__NEp1C"};